import _ from 'lodash';
import IApplicationState from 'app/types/state';

export function getCurrentPerson(state: IApplicationState): any {
  if (state.people.peopleById !== undefined && state.people.currentPersonId !== undefined) {
    return state.people.peopleById[state.people.currentPersonId];
  }
  return {};
}

export function getCurrentFormPerson(state: IApplicationState): any {
  return {
    ...getCurrentPerson(state),
    ...state.people.requestedData,
  };
}

export function getPeople(state: IApplicationState): any {
  return {
    ...state.people,
    currentPerson: getCurrentPerson(state),
    currentFormPerson: getCurrentFormPerson(state),
  };
}

export function getPeopleByIds(peopleById, peopleIds): any {
  if (peopleById !== undefined && peopleIds != null) {
    return _.pick(peopleById, peopleIds);
  }
  return {};
}

export function getPeopleFilteredByCompetitionById(peopleById, competitionId) {
  const filteredPeople = _.filter(peopleById, {
    competition: { id: competitionId },
  });
  const personIds = _.map(filteredPeople, 'id');
  const parsedPeopleById = _.pick(peopleById, personIds);

  return {
    peopleById: parsedPeopleById,
    personIds,
  };
}


export function orderPeopleByName(peopleById): any {
  const orderedPeopleById = _.orderBy(peopleById, ['fullName'], ['asc']);
  const orderedPeopleIds = _.map(orderedPeopleById, 'id');
  return { peopleIds: orderedPeopleIds };
}

export function orderPeople(peopleById, sortConfig): any {
  const keys = _.keys(sortConfig);
  const values = _.map(sortConfig);

  let orderedPeopleIds = _.map(peopleById, 'id');

  if (!_.isEmpty(values)) {
    const orderedPeopleById = _.orderBy(peopleById, keys, values);
    orderedPeopleIds = _.map(orderedPeopleById, 'id');
  }

  return { peopleIds: orderedPeopleIds };
}

export function filterGroupList(groupList, groupType): any {
  const list = groupList;
  const filteredList = _.pickBy(list, (obj) => obj.groupType === groupType);
  return filteredList;
}

export function getPeopleByObjectId(peopleById, object, objectId): any {
  if (peopleById !== undefined && objectId != null) {
    const filteredPeople = _.filter(peopleById, {
      [object]: { id: objectId },
    });

    const peopleIds = _.map(filteredPeople, 'id');
    const newPeopleById = _.pick(peopleById, peopleIds);
    return {
      peopleById: newPeopleById,
      peopleIds,
    };
  }
  return {};
}

export function getPeopleByObjectArrayIncludes(peopleById, object, objectId): any {
  if (peopleById !== undefined && objectId != null) {
    const filteredPeople = _.filter(
      peopleById,
      (person) => person.groups !== undefined && _.includes(person.groups, objectId),
    );

    const peopleIds = _.map(filteredPeople, 'id');
    const newPeopleById = _.pick(peopleById, peopleIds);
    return {
      peopleById: newPeopleById,
      peopleIds,
    };
  }
  return {};
}

export function getPeopleById(people, inputPeopleIds): any {
  if (people.peopleById !== undefined && inputPeopleIds != null) {
    const peopleIds = _.map(inputPeopleIds, 'id');
    const peopleById = _.pick(people.peopleById, peopleIds);

    return {
      peopleById,
      peopleIds,
    };
  }
  return {};
}

export function getPersonSummary(person): any {
  let status = {
    paymentStatus: 'Up to Date',
    paymentStatusColour: 'green',
  };
  const amount = person.paymentStatusAmount;
  switch (person.paymentStatus) {
    case 'owing':
      status = `Owing ${amount}`;
      break;
    case 'overdue':
      status = `Overdue ${amount}`;
      break;
    default:
      status = 'Up to Date';
      break;
  }

  const personSummary = {
    id: person.id,
    fullName: person.fullName,
    tags: person.tagList,
    financialStatus: {
      owingNumber: person.pendingPaymentCollectionsTotalCount,
      overdueNumber: person.overduePaymentCollectionsTotalCount,
    },
    groupName: person.groupName,
    competitionName: person.competitionName,
    sectionName: person.sectionName,
    seasonName: person.seasonName,
    updatedAt: person.updatedAt,
    status,
  };
  return personSummary;
}
